import React, { useCallback, useReducer } from "react";
import { PageHeadingProvider } from "./context";

const HEADING = "HEADING";
const OPTIONS = "OPTIONS";
const APP_NAME = "APP_NAME";
const PAGE_TITLE = "PAGE_TITLE";

const defaultState = {
  [HEADING]: "",
  [OPTIONS]: {},
  [APP_NAME]: "",
  [PAGE_TITLE]: "",
};

function pageHeadingReducer(state, action) {
  let newState = Object.assign({}, state);
  const compareNewToOld = (field, value) => {
    if (newState[field] !== value) {
      newState[field] = value;
    }
  };
  compareNewToOld(action.type, action.payload);
  return newState;
}

const withPageHeading = (WrappedComponent) => {
  function _withPageHeading(props = {}) {
    const componentName =
      WrappedComponent.displayName || WrappedComponent.name || "Component";
    const [pageHeadingContext, setPageHeadingContext] = useReducer(
      pageHeadingReducer,
      defaultState
    );
    const setHeading = useCallback(
      (newValue) =>
        setPageHeadingContext({
          type: HEADING,
          payload: newValue,
        }),
      []
    );
    const setOptions = useCallback(
      (newValue) =>
        setPageHeadingContext({
          type: OPTIONS,
          payload: newValue,
        }),
      []
    );
    const setApplicationName = useCallback(
      (newValue) =>
        setPageHeadingContext({
          type: APP_NAME,
          payload: newValue,
        }),
      []
    );
    const setPageTitle = useCallback(
      (newValue) =>
        setPageHeadingContext({
          type: PAGE_TITLE,
          payload: newValue,
        }),
      []
    );

    const values = {
      heading: pageHeadingContext[HEADING] ?? "",
      options: pageHeadingContext[OPTIONS] ?? {},
      applicationName: pageHeadingContext[APP_NAME] ?? "",
      pageTitle: pageHeadingContext[PAGE_TITLE] ?? "",
      setHeading,
      setOptions,
      setApplicationName,
      setPageTitle,
    };

    _withPageHeading.displayName = `withPageHeading(${componentName})`;

    return (
      <PageHeadingProvider value={values}>
        <WrappedComponent {...props} />
      </PageHeadingProvider>
    );
  }
  return _withPageHeading;
};

export default withPageHeading;
